import { z } from "zod";
// What a practitioner's own session looks like on their day list.
//
// Deliberately smaller than the kiosk's SessionSchema and not derived from it:
// that shape answers "who is in front of this tablet", this one answers "what am
// I running today". It carries no contacts — the roster is Relationships-Australia-WA/Services-Delivery-Technology-Upgrade#348's problem, and a
// group session has no Customer parties at all while it is Scheduled.
//
// `name` is the group's name or the case's title, whichever the session regards.
// A case title generally embeds the client's name, so this list is a
// client-identifying surface: it needs the same care as any client-data screen
// and must never be logged.
export const PractitionerSessionSchema = z.object({
    id: z.guid(),
    // UTC instant. The client formats it to AWST, following SessionSchema — the
    // server does not decide how a time is displayed.
    scheduledStart: z.iso.datetime(),
    name: z.string(),
    programName: z.string(),
    // How the session is delivered. Absent rather than defaulted when the session
    // regards a case: the flag lives on the group, and a case has no group — so
    // there is no value rather than an unknown one. 97.7% of a year's sessions
    // regard a case, so absent is the ordinary state, not the edge.
    deliveryMode: z.enum(["online", "inPerson"]).optional(),
});
// An envelope rather than a bare array, matching the other staff-side responses
// (the kiosk's bare array is the outlier). It also leaves room to add the
// practitioner's own first name later without breaking the contract.
export const PractitionerSessionsResponseSchema = z.object({
    sessions: z.array(PractitionerSessionSchema),
});
// What any route on one of a practitioner's sessions may tell a client beyond
// its status, as an error's code (ADR-033 rule 7). Every such route reads the
// session from ICIS to decide access, so every one can find ICIS out of reach.
export const PractitionerSessionErrorCodeSchema = z.enum(["ICIS_UNAVAILABLE"]);
export const PractitionerSessionErrorCode = PractitionerSessionErrorCodeSchema.enum;
